import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';

export const claimTemplateService = {
  get() {
    return fetch('/api/claim_templates', request.get);
  },
};
